<pp-modal data-testid="export-modal" [attr.data-export-type-count]="exportTypesByPage?.length">
  <ng-container heading> {{ 'export' | ppTranslate }} </ng-container>

  <ng-container body>
    @if (showCsvExportWarning) {
      <pp-point-export-warning />
    }

    <div>
      <pp-select
        [ppItems]="exportTypesByPage"
        [ppSelectedItem]="exportData.selected"
        (ppSelectItem)="selectItem($event)"
        [ppNoSearchBar]="true"
        [ppCustomDropdown]="ppCustomDropdown"
      >
        <ng-container selected>
          @if (!exportData.selected) {
            <p class="siteOptionsExportModal__select-placeholder">
              {{ 'choose_format' | ppTranslate }}
            </p>
          } @else {
            <pp-select-categorised-dropdown-item
              [ppItem]="exportData.selected"
              [ppIsSelected]="true"
            />
          }
        </ng-container>
      </pp-select>
    </div>

    @if (
      exportData.selected?.value === EExportTypeName.SIMPLE_LIST ||
      exportData.selected?.value === EExportTypeName.DETAILED_LIST ||
      exportData.selected?.value === EExportTypeName.PDF ||
      exportData.selected?.value === EExportTypeName.PDF_ZIP ||
      exportData.selected?.value === EExportTypeName.WORD ||
      exportData.selected?.value === EExportTypeName.WORD_SIMPLE
    ) {
      <div>
        <h5 class="modal__body-title--margin">{{ 'page_format' | ppTranslate }}</h5>

        <div class="siteOptionsExportModal__radio-buttons">
          @for (option of exportData.selected?.outputFormat; track option.value) {
            <pp-radio
              [ppChecked]="option.value === exportData.format"
              (ppOnValueChange)="toggleFormat(option)"
              ppStyle="blue"
            >
              <label class="control-custom control-custom--radio">
                {{ option.label }}
              </label>
            </pp-radio>
          }
        </div>
      </div>
    }

    @if (exportData.selected?.value === EExportTypeName.SITE_PLAN) {
      <div>
        <h5 class="modal__body-title--margin">{{ 'page_format' | ppTranslate }}</h5>

        <div class="siteOptionsExportModal__radio-buttons">
          @for (option of exportData.selected?.outputFormat; track option.value) {
            <pp-radio
              [ppChecked]="option.value === exportData.format"
              (ppOnValueChange)="toggleFormat(option)"
              ppStyle="blue"
            >
              <label class="control-custom control-custom--radio">
                {{ option.label }}
              </label>
            </pp-radio>
          }
        </div>
      </div>
    }

    @if (
      exportData.selected?.value === EExportTypeName.SIMPLE_LIST ||
      exportData.selected?.value === EExportTypeName.WORD_SIMPLE ||
      exportData.selected?.value === EExportTypeName.DETAILED_LIST ||
      exportData.selected?.value === EExportTypeName.ZIP ||
      exportData.selected?.value === EExportTypeName.PDF ||
      exportData.selected?.value === EExportTypeName.PDF_ZIP ||
      exportData.selected?.value === EExportTypeName.WORD
    ) {
      <div>
        @if (
          ((exportData.selected?.value === EExportTypeName.SIMPLE_LIST ||
            exportData.selected?.value === EExportTypeName.WORD_SIMPLE) &&
            account?.accountFeatures.pdfSignatures) ||
          (exportData.selected?.value !== EExportTypeName.SIMPLE_LIST &&
            exportData.selected?.value !== EExportTypeName.WORD_SIMPLE)
        ) {
          <h5 class="modal__body-title--margin">
            {{ 'include' | ppTranslate }}
          </h5>
        }

        <div
          data-test="includeCheckboxes"
          [ngClass]="isBrowserSafari ? '' : 'siteOptionsExportModal__options'"
        >
          @for (data of selectedData; track data.id) {
            <ng-container>
              <div class="siteOptionsExportModal__row">
                <pp-checkbox
                  [ppChecked]="exportData[data.id]"
                  [ppDisabled]="fileExportDisabled && data.id === EExportData.FILES"
                  (ppOnValueChange)="toggleValue(data.id)"
                  ppId="{{ data.id }}Checkbox"
                  [attr.aria-label]="data.name"
                >
                  <label class="control-custom control-custom--checkbox">
                    {{ data.name }}
                  </label>
                </pp-checkbox>
              </div>
            </ng-container>
          }
        </div>

        @if (
          exportData.selected?.value === EExportTypeName.DETAILED_LIST ||
          exportData.selected?.value === EExportTypeName.ZIP
        ) {
          <div class="modal__body-container--margin-bottom">
            <h5
              class="modal__body-title--margin capitalise"
              [ngClass]="exportData.showImages ? '' : 'disabledText'"
            >
              {{ 'images' | ppTranslate }}
            </h5>
            <div class="modal__body-radio">
              <pp-radio
                [ppChecked]="!exportData.filterImagesByUpdatedDate"
                (ppOnValueChange)="toggleFilteredImages(false)"
                ppStyle="blue"
                [ppDisabled]="!exportData.showImages"
                ppId="toggleImageFilterFeature"
              >
                <label
                  [ngClass]="exportData.showImages ? '' : 'disabledText'"
                  class="control-custom control-custom--radio"
                >
                  {{ 'all' | ppTranslate }}
                </label>
              </pp-radio>

              <pp-radio
                [ppChecked]="exportData.filterImagesByUpdatedDate"
                (ppOnValueChange)="toggleFilteredImages(true)"
                ppStyle="blue"
                [ppDisabled]="!hasUpdatedDateFilter || !exportData.showImages"
                ppId="toggleImageFilteredByFeature"
              >
                <label class="control-custom control-custom--radio control-custom--radio-with-icon">
                  <span
                    [ngClass]="
                      !hasUpdatedDateFilter || !exportData.showImages ? 'disabledText' : ''
                    "
                  >
                    {{ 'filtered_by' | ppTranslate }}: <b>{{ 'updated_date' | ppTranslate }}</b>
                  </span>
                  <pp-icon
                    [ppColor]="hasUpdatedDateFilter ? 'grey-500' : 'grey-400'"
                    ppTooltip
                    [ppTitle]="'filter_images_by_date' | ppTranslate"
                    [ppSrc]="EIconPath.ICON_MISC_INFO"
                  />
                  <span class="updatedDateFilter">
                    @for (segment of updatedDateSegments; track $index) {
                      <span class="updatedDateFilter__condition">{{ segment.condition }}</span>
                      @if (segment.dates) {
                        <span class="updatedDateFilter__date">({{ segment.dates }})</span>
                      }
                    }
                  </span>
                </label>
              </pp-radio>
            </div>
          </div>
        }

        @if (
          imageSizes &&
          (exportData.selected?.value === EExportTypeName.DETAILED_LIST ||
            exportData.selected?.value === EExportTypeName.WORD ||
            exportData.selected?.value === EExportTypeName.ZIP ||
            exportData.selected?.value === EExportTypeName.PDF ||
            exportData.selected?.value === EExportTypeName.PDF_ZIP)
        ) {
          <div data-test="imageSizes" class="modal__body-container--margin-bottom">
            <h6
              [ngClass]="exportData.showImages ? '' : 'disabledText'"
              class="modal__body-subtitle modal__body-subtitle--margin modal__body-title--images"
            >
              {{ 'images_size' | ppTranslate }}
              <pp-icon
                [ppSrc]="EIconPath.ICON_BADGE_INFO"
                ppColor="grey-400"
                ppTooltip
                [ppTitle]="'prompt_image_export' | ppTranslate"
              />
            </h6>

            <div class="siteOptionsExportModal__options">
              @for (option of imageSizes; track option.value) {
                <div class="siteOptionsExportModal__row">
                  <pp-radio
                    [ppChecked]="option.value === exportData.imagesSize"
                    (ppOnValueChange)="toggleImageSize(option)"
                    [ppDisabled]="!exportData.showImages"
                    ppStyle="blue"
                  >
                    <label
                      class="control-custom control-custom--radio"
                      [ngClass]="exportData.showImages ? '' : 'disabledText'"
                    >
                      {{ option.label }}
                    </label>
                  </pp-radio>
                </div>
              }
            </div>
          </div>
        }

        @if (
          exportData.selected?.value === EExportTypeName.DETAILED_LIST ||
          exportData.selected?.value === EExportTypeName.ZIP
        ) {
          <div class="modal__body-container--margin-bottom">
            <h5
              class="modal__body-title--margin capitalise"
              [ngClass]="!exportData.showComments ? 'disabledText' : ''"
            >
              {{ 'comments' | ppTranslate }}
            </h5>
            <div class="modal__body-radio">
              <pp-radio
                [ppChecked]="!exportData.filterCommentsByUpdatedDate"
                (ppOnValueChange)="toggleFilteredComments(false)"
                ppStyle="blue"
                ppId="toggleFilteredCommentsFeature"
                [ppDisabled]="!exportData.showComments"
              >
                <label
                  class="control-custom control-custom--radio"
                  [ngClass]="!exportData.showComments ? 'disabledText' : ''"
                >
                  {{ 'all' | ppTranslate }}
                </label>
              </pp-radio>

              <pp-radio
                [ppChecked]="exportData.filterCommentsByUpdatedDate"
                (ppOnValueChange)="toggleFilteredComments(true)"
                ppStyle="blue"
                [ppDisabled]="!hasUpdatedDateFilter || !exportData.showComments"
                ppId="toggleCommentsFilteredByDate"
              >
                <label class="control-custom control-custom--radio control-custom--radio-with-icon">
                  <span
                    [ngClass]="
                      !hasUpdatedDateFilter || !exportData.showComments ? 'disabledText' : ''
                    "
                  >
                    {{ 'filtered_by' | ppTranslate }}: <b>{{ 'updated_date' | ppTranslate }}</b>
                  </span>

                  <pp-icon
                    [ppColor]="hasUpdatedDateFilter ? 'grey-500' : 'grey-400'"
                    ppTooltip
                    [ppTitle]="'filter_comments_by_date' | ppTranslate"
                    [ppSrc]="EIconPath.ICON_MISC_INFO"
                  />
                  <span class="updatedDateFilter">
                    @for (segment of updatedDateSegments; track $index) {
                      <span class="updatedDateFilter__condition">{{ segment.condition }}</span>
                      @if (segment.dates) {
                        <span class="updatedDateFilter__date">({{ segment.dates }})</span>
                      }
                    }
                  </span>
                </label>
              </pp-radio>
            </div>
          </div>
        }

        @if (
          exportData.selected?.value === EExportTypeName.DETAILED_LIST ||
          exportData.selected?.value === EExportTypeName.WORD ||
          exportData.selected?.value === EExportTypeName.ZIP ||
          exportData.selected?.value === EExportTypeName.PDF ||
          exportData.selected?.value === EExportTypeName.PDF_ZIP ||
          exportData.selected?.value === EExportTypeName.WORD_SIMPLE ||
          exportData.selected?.value === EExportTypeName.SIMPLE_LIST
        ) {
          <div>
            <pp-toggle
              ppId="toggleURLFeature"
              ppStyle="blue"
              class="marginTop"
              [class.editFeature__toggle--simple]="
                exportData.selected?.value === EExportTypeName.SIMPLE_LIST
              "
              (ppAction)="toggleURL()"
              [ppChecked]="exportData.showUrl"
              [ppReverseLayout]="true"
            >
              <span class="toggleButtonText"> {{ 'add_url_link' | ppTranslate }} </span>

              <pp-icon ppTooltip class="fa fa-info-circle toggleButtonIcon" />
            </pp-toggle>
          </div>
        }

        @if (
          workspace &&
          (exportData.selected?.value === EExportTypeName.ZIP ||
            exportData.selected?.value === EExportTypeName.PDF ||
            exportData.selected?.value === EExportTypeName.PDF_ZIP ||
            exportData.selected?.value === EExportTypeName.DETAILED_LIST) &&
          workspace.customFields.length > 0
        ) {
          <ng-container>
            <h5 class="modal__body-title--margin">{{ 'custom_fields' | ppTranslate }}:</h5>

            <div [ngClass]="isBrowserSafari ? '' : 'siteOptionsExportModal__options'">
              @for (field of customFields; track field.id) {
                <div class="siteOptionsExportModal__row">
                  <pp-checkbox
                    [ppChecked]="field.enabled"
                    (ppOnValueChange)="toggleCustomField(field)"
                    [ppDisabled]="!exportData.showCustomFields"
                  >
                    <label
                      ppTooltip
                      [ppTrimTooltip]="true"
                      [ppTitle]="customFieldList[workspace.workspaceId][field.id]?.label"
                      class="control-custom control-custom--checkbox"
                    >
                      {{ customFieldList[workspace.workspaceId][field.id].label }}
                    </label>
                  </pp-checkbox>
                </div>
              }
            </div>
          </ng-container>
        }
      </div>
    }
  </ng-container>

  <ng-container footer>
    <pp-modal-generic-footer
      [ppConfirmText]="'export' | ppTranslate"
      [ppProcess]="processing"
      [ppDisabled]="!exportData.selected"
      (ppCancel)="hideModal()"
      (ppConfirm)="export()"
    />
  </ng-container>
</pp-modal>
